import { LOAD_PROJECT_ROBUSTNESS, LOAD_PROJECT_ROBUSTNESS_FAILURE } from "../actions/projects";

export default function (state = null, action) {
    switch (action.type) {
        case LOAD_PROJECT_ROBUSTNESS:
            console.log("Robustness Reducer called")
            //localStorage.setItem('newness', JSON.stringify(action.payload));
            //return action.payload;
            return action.payload;

         case LOAD_PROJECT_ROBUSTNESS_FAILURE:
            console.log("Robustness Reducer failure called")
            //localStorage.setItem('newness', JSON.stringify(action.payload));
            //return action.payload;
            return {Error: action.error};

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/robustness.js